import React, { useState } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableCell,
  IconButton,
} from '@mui/material';
import { Edit, Save, Delete, Close } from '@mui/icons-material';
import CustomersFormattedMessages from '../../../messages/admin/CustomersFormattedMessages';

const CommentEdit = ({ item, updateComment, onClickDelete }) => {
  const [commentValue, setCommentValue] = useState(item.customer_comments);
  const [isEditing, setIsEditing] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleChange = (event) => {
    setCommentValue(event.target.value);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  const showConfirmationModal = () => {
    setShowConfirmation(true);
  };

  const saveEdits = () => {
    setIsEditing(false);
    updateComment(item, commentValue);
  };

  return (
    <>
      <TableCell name="comment" colSpan={4}>
        {isEditing ? (
          <TextField
            fullWidth
            id="outlined-basic"
            variant="outlined"
            value={commentValue}
            onChange={handleChange}
            size="small"
          />
        ) : (
          item.customer_comments
        )}
      </TableCell>
      <TableCell name="controlButtons" align="right">
        {isEditing && (
          <IconButton
            title={CustomersFormattedMessages.save}
            onClick={() => saveEdits()}
          >
            <Save />
          </IconButton>
        )}
        <IconButton
          title={
            isEditing
              ? CustomersFormattedMessages.cancel
              : CustomersFormattedMessages.delete
          }
          onClick={() => setIsEditing(!isEditing)}
          size="small"
        >
          {isEditing ? <Close /> : <Edit />}
        </IconButton>
        <IconButton
          title={CustomersFormattedMessages.delete}
          onClick={showConfirmationModal}
          color="error"
          size="small"
        >
          <Delete />
        </IconButton>

        <Dialog open={showConfirmation} onClose={handleCloseConfirmation}>
          <DialogTitle variant="h2">Deletion Confirmation</DialogTitle>
          <DialogContent>
            Are you sure you would like to delete the comment?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseConfirmation}
              color="secondary"
              variant="outlined"
            >
              No
            </Button>
            <Button
              onClick={() => onClickDelete(item)}
              color="secondary"
              variant="contained"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </TableCell>
    </>
  );
};

export default CommentEdit;
